import axios  from "axios";
import { setupInterceptorsTo } from "./interceptor";
import { setupParticipantInterceptorsTo } from "./participantInterceptor";
const url = process.env.REACT_APP_BASE_URL || '/';

export const instance = axios.create({
    baseURL: url,
    headers: {}
});

setupInterceptorsTo(instance)

export const participantInstance = axios.create({
    baseURL: url,
    headers: {}
});

setupParticipantInterceptorsTo(participantInstance)